import { Link, Navigate, useParams } from 'react-router'

import { DRAFT, EFFECTIVE, legalDocs } from '../legal'

/** Small footer row linking the legal pages; shown on sign-in, sign-up and inside the app. */
export function LegalLinks({ exclude = [] }: { exclude?: string[] }) {
  return (
    <nav className="legal-links" aria-label="Informasi hukum">
      {legalDocs
        .filter((d) => !exclude.includes(d.path))
        .map((d) => (
          <Link key={d.path} to={`/${d.path}`}>
            {d.title}
          </Link>
        ))}
    </nav>
  )
}

/** Public: readable without an account (payment providers and merchants look for these). */
export function LegalPage() {
  const { doc } = useParams()
  const page = legalDocs.find((d) => d.path === doc)
  if (!page) return <Navigate to="/" replace />
  return (
    <main className="legal">
      <div className="legal-top">
        <Link to="/">
          <img src="/logo-mark.webp" alt="" width="34" height="36" />
          <span>← GammaPOS</span>
        </Link>
      </div>
      <header className="legal-head">
        <h1>{page.title}</h1>
        <p>Berlaku: {EFFECTIVE}</p>
      </header>
      {DRAFT && (
        <p className="warning" role="note">
          Draf, belum ditinjau penasihat hukum. Isi tanda [kurung] sebelum dipublikasikan.
        </p>
      )}
      <p>{page.intro}</p>
      {page.sections.map((s) => (
        <section key={s.heading}>
          <h2>{s.heading}</h2>
          {s.body.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </section>
      ))}
      <LegalLinks />
    </main>
  )
}
